import { isAuthorized } from 'utils/Auth'
import { getProjects } from './List'
import { createReducer } from '../../utils'

export const PAYMENT_CONFIRMATION_REQUEST = 'sherrinford/order/PaymentConfirmation/PAYMENT_CONFIRMATION_REQUEST'
export const PAYMENT_CONFIRMATION_SUCCESS = 'sherrinford/order/PaymentConfirmation/PAYMENT_CONFIRMATION_SUCCESS'
export const PAYMENT_CONFIRMATION_ERROR = 'sherrinford/order/PaymentConfirmation/PAYMENT_CONFIRMATION_ERROR'

export const CONFIRM_PAYMENT_CONFIRMATION_REQUEST = 'sherrinford/order/PaymentConfirmation/CONFIRM_PAYMENT_CONFIRMATION_REQUEST'
export const CONFIRM_PAYMENT_CONFIRMATION_SUCCESS = 'sherrinford/order/PaymentConfirmation/CONFIRM_PAYMENT_CONFIRMATION_SUCCESS'
export const CONFIRM_PAYMENT_CONFIRMATION_ERROR = 'sherrinford/order/PaymentConfirmation/CONFIRM_PAYMENT_CONFIRMATION_ERROR'

export const GET_INVOICE_REQUEST = 'sherrinford/order/PaymentConfirmation/GET_INVOICE_REQUEST'
export const GET_INVOICE_SUCCESS = 'sherrinford/order/PaymentConfirmation/GET_INVOICE_SUCCESS'
export const GET_INVOICE_ERROR = 'sherrinford/order/PaymentConfirmation/GET_INVOICE_ERROR'

export const IS_LOADING = 'sherrinford/order/PaymentConfirmation/IS_LOADING'
export const DATA = 'sherrinford/order/PaymentConfirmation/DATA'


const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  isLoading: false,
  isError: false,
  errorMessage: '',

  orderStatus: {
    invitationSent: {
      status: 0,
      label: 'Invitation Sent',
    },
    creatorResponded: {
      status: 1,
      label: 'Invitation Sent',
    },
    quotationNeeded: {
      status: 2,
      label: 'Quotation Needed',
    },
    projectOrderNeeded: {
      status: 3,
      label: 'Project Order Needed',
    },
    invoiceNeeded: {
      status: 4,
      label: 'Invoice Needed',
    },
    paymentConfirmation: {
      status: 5,
      label: 'Payment Confirmation',
    },
    ready: {
      status: 6,
      label: 'Ready',
    },
    cancelled: {
      status: 7,
      label: 'Cancelled',
    },
  },

  invoices: {
    count: 10,
    currentPage: 0,
    rows: [],
    totalPages: 0,
  },
}

export default createReducer(initialState, {
  [GET_INVOICE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_INVOICE_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    invoices: {
      ...state.invoices,
      ...data,
    },
  }),
  [GET_INVOICE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [PAYMENT_CONFIRMATION_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PAYMENT_CONFIRMATION_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [PAYMENT_CONFIRMATION_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [CONFIRM_PAYMENT_CONFIRMATION_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [CONFIRM_PAYMENT_CONFIRMATION_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [CONFIRM_PAYMENT_CONFIRMATION_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),
})

export const getPaymentConfirmation = (qs, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return (dispatch) => {
    const pendingStatus = {
      status: initialState.orderStatus.paymentConfirmation.status,
    }
    const projectSearch = {
      search: JSON.stringify(pendingStatus),
    }
    dispatch(getProjects(projectSearch, (res) => {
      const orderId = res.rows.length === 0
        ? []
        : res.rows.map(order => order.id)
      const searchParam = {
        order: orderId,
      }
      const toDispatch = {
        type: [
          PAYMENT_CONFIRMATION_REQUEST,
          PAYMENT_CONFIRMATION_SUCCESS,
          PAYMENT_CONFIRMATION_ERROR,
        ],
        shuttle: {
          method: 'GET',
          path: '/order_payment',
          authorization: `${token}`,
          payloads: qs,
          qs: {
            search: JSON.stringify(searchParam),
          },
        },
        nextAction: (nextRes) => {
          cb(nextRes)
        },
      }
      return dispatch(toDispatch)
    }))
  }
}

export const confirmPaymentConfirmation = (id, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  const status = {
    status: initialState.orderStatus.ready.status,
  }
  return {
    type: [
      CONFIRM_PAYMENT_CONFIRMATION_REQUEST,
      CONFIRM_PAYMENT_CONFIRMATION_SUCCESS,
      CONFIRM_PAYMENT_CONFIRMATION_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/order/${id}/status`,
      payloads: status,
      authorization: `${token}`,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const getInvoices = (searchParams = {}, pages = {
  sort: 'createdAt DESC',
  limit: 10,
  skip: 0,
}, cb = () => {}) => ({
  type: [
    GET_INVOICE_REQUEST,
    GET_INVOICE_SUCCESS,
    GET_INVOICE_ERROR,
  ],
  shuttle: {
    method: 'GET',
    path: '/invoice',
    qs: {
      search: JSON.stringify(searchParams),
      ...pages,
    },
  },
  nextAction: (res) => {
    cb(res)
  },
})
